export default {
      id: "phone-orange-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#phone-orange",
      toString: function () {
        return this.url;
      }
    }